import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './data/store'
window.axios = require('axios');
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
 

const app = createApp(App);

app.use(router).use(store).mount('#app')
